// Wrapper fino sobre las Cloud Functions de organizaciones (Postgres/Neon).
// Organizaciones: grupo de usuarios que comparte una sola bolsa de créditos
// de IA. Todo superadmin-only, se gestiona desde Mantenedor.
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const crearOrganizacionFn = httpsCallable(functions, 'crearOrganizacion');
const listarOrganizacionesFn = httpsCallable(functions, 'listarOrganizaciones');
const actualizarOrganizacionFn = httpsCallable(functions, 'actualizarOrganizacion');
const eliminarOrganizacionFn = httpsCallable(functions, 'eliminarOrganizacion');
const asignarUsuarioAOrganizacionFn = httpsCallable(functions, 'asignarUsuarioAOrganizacion');

export async function crearOrganizacion(nombre, creditosIa) {
  const result = await crearOrganizacionFn({ nombre, creditosIa });
  return result.data.organizacion;
}

// [{ id, nombre, creditosIa, miembros: [{uid, nombre, email, rol}] }]
export async function listarOrganizaciones() {
  const result = await listarOrganizacionesFn();
  return result.data.organizaciones;
}

export async function actualizarOrganizacion(id, datos) {
  const result = await actualizarOrganizacionFn({ id, ...datos });
  return result.data.organizacion;
}

export async function eliminarOrganizacion(id) {
  await eliminarOrganizacionFn({ id });
}

// organizationId null saca al usuario de su organización actual.
export async function asignarUsuarioAOrganizacion(uid, organizationId) {
  await asignarUsuarioAOrganizacionFn({ uid, organizationId });
}
